module.exports = __webpack_public_path__ + "static/egglife-t-023ddc314fc198fadec640872506e147.mp4";